import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=14e011ca&scoped=true&"
import script from "./copy.js?vue&type=script&lang=js&"
export * from "./copy.js?vue&type=script&lang=js&"
import style0 from "./copy.vue?vue&type=style&index=0&id=14e011ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e011ca",
  null
  
)

export default component.exports